import { render, staticRenderFns } from "./rankingrenew.vue?vue&type=template&id=35bf41f8&scoped=true&"
import script from "./rankingrenew.vue?vue&type=script&lang=ts&"
export * from "./rankingrenew.vue?vue&type=script&lang=ts&"
import style0 from "./rankingrenew.vue?vue&type=style&index=0&id=35bf41f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf41f8",
  null
  
)

export default component.exports